<template>
  <v-dialog v-model="dialog" max-width="960">
      <template #activator="{on}" v-if="box.order_id">
          <v-btn text v-on="on">
              Detail
           </v-btn>
      </template>
      <v-card :disabled="loading">
          <v-toolbar flat>
              <v-toolbar-title>
                Detail of pending box : "{{box.name}}"
              </v-toolbar-title>
                <v-spacer />
                <ManualPicking :box="box" @refresh="$emit('refresh')" />
          </v-toolbar>
          <v-container>
            <v-row v-if="box.order_id">
                <v-col>
                    <v-row>
                        <v-col>
                            Order Id : <span class="font-weight-bold">#{{box.order_id}}</span>
                        </v-col>
                        <v-col>
                            Client : <span class="font-weight-bold">{{box.client.displayName}}</span>
                        </v-col>
                        <v-col>
                            Build Status : <v-chip :color="box.build.status_id=='backordered'?'danger':'primary'" small>{{box.build.status_id}}</v-chip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h2 class="text-h6">Products in this box</h2>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                SKU
                                            </th>
                                            <th class="text-left">
                                                Product Name
                                            </th>
                                            <th class="text-left">
                                                Quantity
                                            </th>
                                            <th>
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                        v-for="item in box.items"
                                        :key="item.id"
                                        >
                                            <td>{{ item.product.sku }}</td>
                                            <td>{{ item.product.name }}</td>
                                            <td>{{ item.quantity }}</td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click="returnToStock(item)"
                                                        >
                                                            <v-icon>mdi-warehouse</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Return to stock</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </tbody>
                                    </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
              <v-dialog v-model="moveDialog" v-if="box.order_id" persistent>
                  <template #activator="{ on }">
                      <v-btn v-on="on" color="orange">
                          Assign order to another box
                       </v-btn>
                  </template>
            
                <v-card :disabled="loading">
                    <v-card-title>Choose empty box</v-card-title>
                    <v-card-text>
                        <v-select
                            :items="emptyBox"
                            label="Empty box"
                            item-text="name"
                            v-model="choosedBox"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="moveDialog=false">Cancel</v-btn>
                        <v-spacer />
                        <v-btn @click="move">Move</v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer />
              <v-btn color="red" dark v-if="box.items.length" @click="returnAll">Return all product to stock</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ManualPicking from './ManualPicking.vue';
export default {
    components:{
        ManualPicking
    },
    props:{
        value: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        dialog:false,
        moveDialog:false,
        choosedBox:null
    }),
    watch: {
        moveDialog(val) {
            if(val == true){
                this.getEmptyBox();
            }
        }
    },
    computed:{
        ...mapGetters('pendingbox', ['loading', 'emptyBox']),
        box: {
            get: function() {
                return this.value;
            },
            set: function(value) {
                this.$emit("input", value);
            }
        }
    },
    methods: {
        ...mapActions('pendingbox',["returnProductToStock", "returnAllProductsToStock", "getEmptyBox", "assignToAnotherBox"]),
        returnToStock(item) {
            this.returnProductToStock({
                boxId: this.box.id,
                productId: item.product_id
            })
            .then(({pendingBox}) => {
                this.box = pendingBox;
            })
            //this.$store.dispatch("cart/returnToStock", item);
        },

        returnAll(){
            this.returnAllProductsToStock(this.box.id)
            .then(({pendingBox}) => {
                this.box = pendingBox;
            })
        },

        move(){
            if(this.choosedBox){
                this.assignToAnotherBox({
                    currentId: this.box.id,
                    newId: this.choosedBox
                })
                .then(() => {
                    this.$emit("refresh");
                    this.dialog=false
                })
            }
        }
    }
}
</script>

<style>

</style>